import { DeploymentModule } from './../deployment/deployment.module';
import { StorageRoutingModule } from './storage-routing.module';
import { CommonModule, TitleCasePipe } from "@angular/common";
import { NgModule } from "@angular/core";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { BrowserModule } from "@angular/platform-browser";
import { NgxSpinnerModule } from 'ngx-spinner';
import { AppRoutingModule } from "src/app/app-routing.module";
import { StorageDataTransferComponent } from "./components/storage-data-transfer/storage-data-transfer.component";
import { StorageDetailsComponent } from './components/storage-details/storage-details.component';
import { StorageLeftPanelComponent } from "./components/storage-left-panel/storage-left-panel.component";
import { StorageListComponent } from "./components/storage-list/storage-list.component";
import { StorageMainPanelComponent } from './components/storage-main-panel/storage-main-panel.component';
import { StorageParentListComponent } from "./components/storage-parent-list/storage-parent-list.component";
import { StorageSettingComponent } from "./components/storage-setting/storage-setting.component";
import { AngularMaterialModule } from 'src/app/shared/material-module';
import { FileSizePipe } from 'src/app/core/pipes/file-size.pipe';
import { NgxPaginationModule } from 'ngx-pagination';
import { CoreModule } from 'src/app/core/core.module';
import { CreateDirectoryComponent } from './modals/create-directory/create-directory.component';
import { DeleteConfirmComponent } from './modals/delete-confirm/delete-confirm.component';
import { NgbModule, NgbNavModule } from '@ng-bootstrap/ng-bootstrap';
import { FileUploadModule } from 'ng2-file-upload';
import { RenameComponent } from './modals/rename/rename.component';
import { ResizableModule } from '../../core/directive/resizable/resizable.module';
import { SharedModule } from '../shared/shared.module';
import { FileAlreadyExistsActionComponent } from './modals/file-already-exists-action/file-already-exists-action.component';
import { CustomDatePipe } from '../../core/pipes/custom-date.pipe';
import { NewStorageComponent } from './modals/new-storage/new-storage.component';
import { NgSelectModule } from '@ng-select/ng-select';
import {CdkMenuModule} from '@angular/cdk/menu';
import { ViewFileComponent } from './modals/view-file/view-file.component';

@NgModule({
  declarations: [
      StorageDetailsComponent,
      StorageListComponent,
      StorageMainPanelComponent,
      StorageDataTransferComponent,
      StorageSettingComponent,
      StorageLeftPanelComponent,
      StorageParentListComponent,
      CreateDirectoryComponent,
      DeleteConfirmComponent,
      RenameComponent,
      FileAlreadyExistsActionComponent,
      NewStorageComponent,
      ViewFileComponent
    ],
    imports: [
      AppRoutingModule,
      CommonModule,
      BrowserModule,
      ReactiveFormsModule,
      FormsModule,
      CoreModule,
      NgxSpinnerModule,
      NgxPaginationModule,
      StorageRoutingModule,
      AngularMaterialModule,
      NgbModule,
      FileUploadModule,
      ResizableModule,
      SharedModule,
      NgSelectModule,
      CdkMenuModule,
      NgbNavModule,
  ],
  providers: [FileSizePipe, CustomDatePipe, TitleCasePipe],
})
export class StorageModule { }
